export const pathLegalNotice = "/legal-notice";
